<div
  #modalContents
  class="l-modal04__contents u-modal-size-pc-768 js-modal-contents"
  aria-modal="true"
  role="dialog"
  aria-labelledby="seatmap-layout-detail-modal-title"
>
  <div #modalHead [class]="[lmodalHeaderClass, 'p-modal-head07']">
    <!-- （モーダルのヘッダ部分のHMML） -->
    <h1
      id="seatmap-confirm-seat-reservation-title"
      class="p-modal-head07__title"
      innerHTML="{{ 'm_static_message-heading.confirmSeatReservation' | staticMsg }}"
    ></h1>
    <!-- [閉じるボタン] -->
    <button
      id="seatmap-confirm-seat-reservation-close"
      class="p-modal-head07__close js-modal-close"
      aswThrottleClick
      (throttleClick$)="close()"
    >
      <span class="u-visually-hidden" innerHTML="{{ 'm_static_message-alt.closeModal' | staticMsg }}"></span>
    </button>
    <!-- //[閉じるボタン] -->
  </div>
  <!-- セグメント情報 -->
  <div
    #modalBody
    [class]="[lmodalBodyClass, 'l-modal04__body', 'modal-body-not-scroll']"
    style="height: 68.625px"
    tabindex="0"
  >
    <!-- （モーダルのメイン部分のHTML） -->
    <div class="p-modal-seatmap-confirm">
      <!-- [セグメント情報] -->
      <div class="p-modal-seatmap-confirm__item" *ngFor="let segment of getSegmentChangeList()">
        <div class="p-modal-seatmap-confirm__title">
          <!-- [出発日] -->
          <div class="p-modal-seatmap-confirm__title-date">
            {{ segment.departure?.dateTime || '' | dateFormat : 'default_departuredate' : true }}
          </div>
          <!-- //[出発日] -->
          <!-- [出発地 - 到着地] -->
          <div class="p-modal-seatmap-confirm__title-airport">
            <span class="p-modal-seatmap-confirm__title-airport-departure">
              {{ (segment.departure?.locationCode | airportNameI18n) || segment.departure?.locationName }}
              <span class="p-modal-seatmap-confirm__title-airport-to">
                <span
                  class="u-visually-hidden"
                  innerHTML="{{ 'm_static_message-alt.toOfArrivalAndDeparture' | staticMsg }}"
                ></span>
                <span aria-hidden="true">{{ 'label.hyphen' | staticMsg }}</span>
              </span>
            </span>
            <span class="p-modal-seatmap-confirm__title-airport-arrival">
              {{ (segment.arrival?.locationCode | airportNameI18n) || segment.arrival?.locationName }}
            </span>
          </div>
          <!-- //[出発地 - 到着地] -->
        </div>

        <!-- [搭乗者情報] -->
        <div
          class="p-modal-seatmap-confirm__contents"
          *ngFor="let passengerId of getDisplayPassengerList(segment.id); index as i"
        >
          <!-- カウチ席 -->
          <div
            class="p-modal-seatmap-confirm__contents-item"
            *ngIf="isCouchSeat(passengerId, segment.id) && !isAlreadyShown(segment.id, passengerId)"
          >
            <dl
              class="c-float-list03"
              *ngFor="let passengerName of getSameCouchPassengers(segment.id, passengerId); index as samePassengerIndex"
            >
              <!-- 搭乗者情報 -->
              <div *ngIf="samePassengerIndex > 0" class="c-float-list03__item c-float-list03__item--mt4">
                <dt class="c-float-list03__title">
                  <div class="c-float-list03__title-item c-float-list03__title-item--em">{{ passengerName }}</div>
                  <div
                    class="c-float-list03__title-item c-float-list03__title-item--gray60"
                    *ngIf="getInfantName(passengerName)"
                  >
                    {{ getInfantName(passengerName) }}
                  </div>
                </dt>
                <dd
                  class="c-float-list03__contents c-float-list03__contents--fs16"
                  *ngIf="travelersMap?.get(passengerId)?.name === passengerName"
                >
                  {{ getSeatNumber(passengerId, segment.id) || ('m_static_message-label.hyphen3' | staticMsg) }}
                </dd>
              </div>
              <div *ngIf="samePassengerIndex <= 0" class="c-float-list03__item">
                <dt class="c-float-list03__title">
                  <div class="c-float-list03__title-item c-float-list03__title-item--em">{{ passengerName }}</div>
                  <div
                    class="c-float-list03__title-item c-float-list03__title-item--gray60"
                    *ngIf="getInfantName(passengerName)"
                  >
                    {{ getInfantName(passengerName) }}
                  </div>
                </dt>
                <dd
                  class="c-float-list03__contents c-float-list03__contents--fs16"
                  *ngIf="travelersMap?.get(passengerId)?.name === passengerName"
                >
                  {{ getSeatNumber(passengerId, segment.id) || ('m_static_message-label.hyphen3' | staticMsg) }}
                </dd>
              </div>
              <!-- // 搭乗者情報 -->
            </dl>
          </div>
          <!-- カウチ席以外 -->
          <div class="p-modal-seatmap-confirm__contents-item" *ngIf="!isCouchSeat(passengerId, segment.id)">
            <dl class="c-float-list03">
              <!-- 搭乗者情報 -->
              <div class="c-float-list03__item">
                <!-- [搭乗者姓名] -->
                <dt class="c-float-list03__title">
                  <div class="c-float-list03__title-item c-float-list03__title-item--em">
                    {{ travelersMap?.get(passengerId)?.name }}
                  </div>
                  <div
                    class="c-float-list03__title-item c-float-list03__title-item--gray60"
                    *ngIf="getInfantName(travelersMap?.get(passengerId)?.name)"
                  >
                    {{ getInfantName(travelersMap?.get(passengerId)?.name) }}
                  </div>
                </dt>
                <!-- //[搭乗者姓名] -->
                <!-- [座席指定状況] -->
                <dd
                  class="c-float-list03__contents c-float-list03__contents--fs16"
                  *ngIf="getSeatNumber(passengerId, segment.id)"
                >
                  {{ getSeatNumber(passengerId, segment.id) }}
                </dd>
                <!-- //[座席指定状況] -->
                <dd
                  class="c-float-list03__contents c-float-list03__contents--fs16 c-float-list03__contents--gray40"
                  *ngIf="!getSeatNumber(passengerId, segment.id)"
                >
                  {{ 'm_static_message-label.hyphen3' | staticMsg }}
                </dd>
              </div>
              <!-- // 搭乗者情報 -->
              <!-- 有料サービス料金情報　※有料席のみ表示 -->
              <div class="c-float-list03__item" *ngIf="isChargeableAsrSeat(passengerId, segment.id)">
                <!-- 座席種別 -->
                <dt class="c-float-list03__title c-float-list03__title--gray60">
                  {{
                    isChargeableAsrSeat(passengerId, segment.id) ? ('m_static_message-label.paidSeat' | staticMsg) : ''
                  }}
                </dt>
                <!-- // 座席種別 -->
                <!-- 座席料金　※料金が0より大きい場合のみ表示 -->
                <dd
                  class="c-float-list03__contents c-float-list03__contents--fs16"
                  *ngIf="getSeatPrice(passengerId, segment.id) > 0"
                >
                  <span class="c-amount c-amount--price">
                    <span class="c-amount__num c-amount__num--fs16">
                      {{ getSeatPrice(passengerId, segment.id) | amountFormat }}
                    </span>
                  </span>
                </dd>
                <!-- // 座席料金 -->
              </div>
              <!-- // 有料サービス料金情報 -->
            </dl>
          </div>
        </div>
        <!-- //[搭乗者情報] -->
      </div>
      <!-- //[セグメント情報] -->
    </div>
  </div>
  <!-- // セグメント情報 -->

  <!-- 「内容確定・購入確認文言、内容確定・購入へ」 -->
  <div #modalFooter [class]="['l-modal05__footer', 'js-modal-footer', 'is-shadow']" *ngIf="!isConfirmClick">
    <div class="p-modal-foot05" *ngIf="!isConfirmClick">
      <!-- 内容確定・購入確認文言　※保存して終了ボタン押下の場合（確認ボタン押下ではない場合）、かつ、事前座席指定以外の有料サービスを申し込んでいない場合に表示する -->
      <div
        class="p-modal-foot05__item"
        innerHTML="{{ getConfirmLabelStaticMsgKey() | staticMsg }}"
        *ngIf="!isConfirmClick && !isOtherPaidServices()"
      ></div>
      <!-- // 内容確定・購入確認文言 -->
      <!-- 内容確定・購入へ　※保存して終了ボタン押下の場合（確認ボタン押下ではない場合）に表示する -->
      <div class="p-modal-foot05__item">
        <div class="p-modal-foot05__btn">
          <!-- 内容確定・購入へ -->
          <div class="p-modal-foot05__btn-item p-modal-foot05__btn-item--center">
            <asw-button
              id="seatmap-apply-service-button"
              type="primary"
              aswThrottleClick
              (click$)="onClickApplyService()"
              size="s"
            >
              <span
                class="c-btn-primary__text c-btn-primary--min-w180"
                innerHTML="{{ getApplyButtonStaticMsgKey() | staticMsg }}"
              ></span>
            </asw-button>
          </div>
          <!-- // 内容確定・購入へ -->
        </div>
      </div>
      <!-- // 内容確定・購入へ -->
    </div>
  </div>
  <!-- // 「内容確定・購入確認文言、内容確定・購入へ」 -->
</div>
